import React from 'react';
import axios from 'src/utils/axios'
import AttachFileIcon from '@material-ui/icons/Attachment';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import DashboardIcon from '@material-ui/icons/Dashboard';
import FormatListBulletedIcon from '@material-ui/icons/ImportContacts';
import HelpIcon from '@material-ui/icons/Help';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import AddToHomeScreenIcon from '@material-ui/icons/AddToHomeScreen';
import CompareIcon from '@material-ui/icons/Compare';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import PostAddIcon from '@material-ui/icons/PostAdd';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import StoreIcon from '@material-ui/icons/Store';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ReportIcon from '@material-ui/icons/Report';
import { FaSave, FaTruck } from "react-icons/fa";
import { GoDeviceMobile, GoLocation } from "react-icons/go";
import { RiMessage2Line } from "react-icons/ri";
import Label from 'src/components/Label';
import { forms } from 'src/views/Form';
import PaymentIcon from '@material-ui/icons/Payment';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import { FaFileInvoice, FaMapSigns } from "react-icons/fa";
import { AiFillShop } from "react-icons/ai";
import { colors } from '@material-ui/core';
import { text } from "../../modules/languages/index";
import { SiNintendoswitch } from "react-icons/si";
import SlowMotionVideoIcon from '@material-ui/icons/SlowMotionVideo';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import ExploreIcon from '@material-ui/icons/Explore';
import LocalConvenienceStoreIcon from '@material-ui/icons/LocalConvenienceStore';
import { MdVideoCall } from "react-icons/md";
import CropFreeIcon from '@material-ui/icons/CropFree';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import WorkIcon from '@material-ui/icons/Work';
import ExtensionIcon from '@material-ui/icons/Extension';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ScheduleIcon from '@material-ui/icons/Schedule';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';
import TimelapseIcon from '@material-ui/icons/Timelapse';
import LocalCarWashIcon from '@material-ui/icons/LocalCarWash';
import CompassCalibrationIcon from '@material-ui/icons/CompassCalibration';
import SearchIcon from '@material-ui/icons/Search';
import AccessibilityNewIcon from '@material-ui/icons//AccessibilityNew';
import PersonelKarti from '@material-ui/icons/CreditCard';
import BatteryAlertIcon from '@material-ui/icons/BatteryAlert';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import AudioAnalyzerIcon from '@material-ui/icons/Audiotrack';
import logger from 'src/utils/logger';

const iconPaths = {
  'AttachFileIcon': AttachFileIcon,
  'ChatIcon': ChatIcon,
  'CreditCardIcon': CreditCardIcon,
  'DashboardIcon': DashboardIcon,
  'FormatListBulletedIcon': FormatListBulletedIcon,
  'RecentActorsIcon': RecentActorsIcon,
  'HelpIcon': HelpIcon,
  'HomeIcon': HomeIcon,
  'LocalShippingIcon': LocalShippingIcon,
  'NotificationImportantIcon': NotificationImportantIcon,
  'AddToHomeScreenIcon': AddToHomeScreenIcon,
  'CompareIcon': CompareIcon,
  'PersonIcon': PersonIcon,
  'PostAddIcon': PostAddIcon,
  'ShoppingCartIcon': ShoppingCartIcon,
  'StoreIcon': StoreIcon,
  'ThumbUpAltIcon': ThumbUpAltIcon,
  'SiNintendoswitch': SiNintendoswitch,
  'ReportIcon': ReportIcon,
  'SlowMotionVideoIcon': SlowMotionVideoIcon,
  'SettingsRemoteIcon': SettingsRemoteIcon,
  'ExploreIcon': ExploreIcon,
  'LocalConvenienceStoreIcon': LocalConvenienceStoreIcon,
  'CropFreeIcon': CropFreeIcon,
  'SupervisorAccountIcon': SupervisorAccountIcon,
  'WorkIcon': WorkIcon,
  'ExtensionIcon': ExtensionIcon,
  'ScheduleIcon': ScheduleIcon,
  'AccountBalanceWalletIcon': AccountBalanceWalletIcon,
  'AllInboxIcon': AllInboxIcon,
  'DepartureBoardIcon': DepartureBoardIcon,
  'TimelapseIcon': TimelapseIcon,
  'LocalCarWashIcon': LocalCarWashIcon,
  'CompassCalibrationIcon': CompassCalibrationIcon,
  'SearchIcon': SearchIcon,
  'AssessmentIcon': AssessmentIcon,
  'AccessibilityNewIcon': AccessibilityNewIcon,
  'BatteryAlertIcon': BatteryAlertIcon,
  'CardMembershipIcon': CardMembershipIcon,
  'ContactSupportIcon': ContactSupportIcon,
  'AudioAnalyzerIcon': AudioAnalyzerIcon,
};
function getPath(iconName) {
  if (iconPaths[iconName]) {
    return iconPaths[iconName];
  } else {
    return '';
  }
}
function getLabel(href, label) {
  if (label) {
    if (href === '/overview') {
      return () => (<Label
        color={colors.green[500]}
        shape="rounded"
      >
        {getIslerAdet()}
      </Label>)
    }
    if (href === '/MalzemeIhtiyac') {
      return () => (<Label
        color={colors.blue[500]}
        shape="rounded"
      >
        {getMalzemeIhtiyacAdet()}
      </Label>)
    }
    if (href === '/UyariMerkezi') {
      return () => (<Label
        color={colors.red[500]}
        shape="rounded"
      >
        {getUyariAdet()}
      </Label>)
    }
    if (href === '/chat') {
      return () => (<Label
        color={"#8b8b00"}
        shape="rounded"
      >
        {getYorumAdet()}
      </Label>)
    }
    if (href === '/Satis') {
      return () => (<Label
        color={"#ecab53"}
        shape="rounded"
      >
        {getSatisAdet()}
      </Label>)
    }


  }
}
function getItems(href, items) {
  if (items) {
    if (href === '/CentralPaperControl') {
      return [
        {
          title: 'Fiş Sorgu',
          icon: FaFileInvoice,
          href: '/CentralPaperControl'
        },
        {
          title: 'Değişim Eskisi Kabul',
          icon: SiNintendoswitch,
          href: '/ProductChangeScrap'
        },
        {
          title: 'Stok Nerede ?',
          icon: FaMapSigns,
          href: '/MaterialFind'
        },
        {
          title: 'Görüntülü Destek',
          icon: MdVideoCall,
          href: '/VideoHelper'
        },
        {
          title: 'Bayi-Servis Ziyareti',
          icon: AiFillShop,
          href: '/DealerVisit'
        },
        {
          title: 'Kredi Limit',
          icon: CardMembershipIcon,
          href: '/Credit'
        },
        {
          title: 'Ek Garanti Satış Takip',
          icon: PaymentIcon,
          href: '/ExtraWarrantySalesList'
        },
         {
          title: 'Sesten Arıza Tanıma',
          icon: AudioAnalyzerIcon,
          href: '/DefectSoundRecognition'
        },
      ]
    }
    if (href === '/Form') {
      return forms.map(f => {
        return {
          title: f.value,
          href: `/Form/${f.key}/1`,
          icon: f.iconObj,
          FormTitle: f.value
        }
      })
    }
    if (href === '/profile') {
      return [
        {
          title: "Mesajlar",
          icon: RiMessage2Line,
          href: "/profile/1/timeline"
        },
        {
          title: "Cİhaz",
          icon: GoDeviceMobile,
          href: "/profile/1/connections"
        },
        {
          title: "Plaka",
          icon: FaTruck,
          href: "/profile/1/Plaka"
        },
        {
          title: "Kayıt",
          icon: FaSave,
          href: "/profile/1/Kayit"
        },        
        {
          title: "Lokasyon",
          icon: GoLocation,
          href: "/profile/1/Lokasyon"
        },
        {
          title: 'Digiport',
          icon: ReportIcon,
          href: '/profile/1/Digiport'
        }
      ]
    }
    if (href === '/Performance') {
      return [
        {
          title: 'Ek-Garanti',
          icon: ExtensionIcon,
          href: '/Performance/1/EkGaranti'
        },
        {
          title: 'Tamamlayici Ürün',
          icon: WorkIcon,
          href: '/Performance/1/Tamamlayici'
        },
      ]
    }

    if (href === '/Raporlar') {
      return [
        {
          title: 'Randevuya Uyum',
          icon: ScheduleIcon,
          href: '/Scheduling'
        },
        {
          title: 'Teknisyen Gelir',
          icon: AccountBalanceWalletIcon,
          href: '/Money'
        },
        {
          title: 'Evde/Yolda Geçen Süre',
          icon: LocalShippingIcon,
          href: '/Time'
        },
        {
          title: 'NPS',
          icon: AssessmentIcon,
          href: '/NPS'
        },
        {
          title: 'Depo ve Zimmet Tutarları',
          icon: AllInboxIcon,
          href: '/WareHouseControl'
        },
        {
          title: 'SLA Takibi',
          icon: DepartureBoardIcon,
          href: '/SLA'
        },
        {
          title: 'Açık İşler',
          icon: TimelapseIcon,
          href: '/OpenWork'
        },
        {
          title: 'Bir Defada Hizmet',
          icon: LocalCarWashIcon,
          href: '/OneTimeService'
        },
        {
          title: 'Şikayet',
          icon: CompassCalibrationIcon,
          href: '/ComplaintReport'
        },
        {
          title: 'Fiş Sorgulama',
          icon: SearchIcon,
          href: '/CentralPaperControlServiceShop'
        },
        {
          title: '3 Günde Çözüm',
          icon: AccessibilityNewIcon,
          href: '/Solution3Days'
        },
        {
          title: 'Cari Hesap',
          icon: AccountBalanceWalletIcon,
          href: '/CariHesap'
        },

      ]
    }



  }
}
export const getMenu = () => {
  const MenuReturnData = [];

  let MenuCount = JSON.parse(sessionStorage.getItem('MenuData') || null);
  if (MenuCount === null) {
    MenuCount = JSON.parse(localStorage.getItem('MenuData') || null);
  }
  if (MenuCount === null || MenuCount === undefined) {
    return DefaultMenu;
  }
  if (MenuCount.length > 0) {
    MenuCount.forEach(item => {
      MenuReturnData.push({
        title: item.title,
        href: item.href,
        icon: getPath(item.icon),
        label: getLabel(item.href, item.label),
        items: getItems(item.href, item.items)
      });
    });
  } else {
    return DefaultMenu;
  }





  return MenuReturnData;
}

const DefaultMenu = [
  {
    title: text('is_emirleri'),
    href: '/overview',
    icon: DashboardIcon,
    label: () => (
      <Label
        color={colors.green[500]}
        shape="rounded"
      >
        {getIslerAdet()}
      </Label>
    )
  },
  {
    title: 'Malzeme İhtiyacım',
    href: '/MalzemeIhtiyac',
    icon: ShoppingCartIcon,
    label: () => (
      <Label
        color={colors.blue[500]}
        shape="rounded"
      >
        {getMalzemeIhtiyacAdet()}
      </Label>
    )
  },
  {
    title: text('Uyari_Merkezi'),
    href: '/UyariMerkezi',
    klima_teknisyeni_gizle: true,
    icon: NotificationImportantIcon,
    label: () => (
      <Label
        color={colors.red[500]}
        shape="rounded"
      >
        {getUyariAdet()}
      </Label>
    )
  },
  {
    title: text('Yorum'),
    href: '/chat',
    klima_teknisyeni_gizle: true,
    icon: ChatIcon,
    label: () => (
      <Label
        color={'#8b8b00'}
        shape="rounded"
      >
        {getYorumAdet()}
      </Label>
    )
  },
  {
    title: 'Malzeme Depo Talep',
    href: '/MaterialRequest',
    icon: AddToHomeScreenIcon,

  },
  {
    title: 'QR Etiket Eşle',
    href: '/QrBarcodeMap',
    icon: CropFreeIcon,


  },
  {
    title: 'Malzeme Eskisi',
    href: '/Scrap',
    icon: BatteryAlertIcon,


  },
  {
    title: 'Formlar',
    href: '/Form',
    icon: PostAddIcon,
    items: forms.map(f => {
      return {
        title: f.value,
        href: `/Form/${f.key}/1`,
        icon: f.iconObj,
        FormTitle: f.value
      }
    })
  },
  {
    title: "Satış",
    href: '/Satis',
    klima_teknisyeni_gizle: true,
    icon: CreditCardIcon,
    label: () => (
      <Label
        color={'#ecab53'}
        shape="rounded"
      >
        {getSatisAdet()}
      </Label>
    )
  },
  {
    title: "Performans",
    href: '/Performance',
    icon: SupervisorAccountIcon,
    items: [
      {
        title: 'Ek-Garanti',
        icon: ExtensionIcon,
        href: '/Performance/1/EkGaranti'
      },
      {
        title: 'Tamamlayici Ürün',
        icon: WorkIcon,
        href: '/Performance/1/Tamamlayici'
      },
    ]
  },
  {
    title: "Raporlar",
    href: '/Raporlar',
    icon: AssessmentIcon,
    items: [
      {
        title: 'Randevuya Uyum',
        icon: ScheduleIcon,
        href: '/Scheduling'
      },
      {
        title: 'Teknisyen Gelir',
        icon: AccountBalanceWalletIcon,
        href: '/Money'
      },
      {
        title: 'Evde/Yolda Geçen Süre',
        icon: LocalShippingIcon,
        href: '/Time'
      },
      {
        title: 'NPS',
        icon: AssessmentIcon,
        href: '/NPS'
      },
      {
        title: 'Depo ve Zimmet Tutarları',
        icon: AllInboxIcon,
        href: '/WareHouseControl'
      },
      {
        title: 'SLA Takibi',
        icon: DepartureBoardIcon,
        href: '/SLA'
      },
      {
        title: 'Açık İşler',
        icon: TimelapseIcon,
        href: '/OpenWork'
      },
      {
        title: 'Bir Defada Hizmet',
        icon: LocalCarWashIcon,
        href: '/OneTimeService'
      },
      {
        title: 'Şikayet',
        icon: CompassCalibrationIcon,
        href: '/ComplaintReport'
      },
      {
        title: 'Fiş Sorgulama',
        icon: SearchIcon,
        href: '/CentralPaperControlServiceShop'
      },
      {
        title: '3 Günde Çözüm',
        icon: AccessibilityNewIcon,
        href: '/Solution3Days'
      },

    ]
  },
  {
    title: "Ürün Kabul",
    href: '/UrunKabul',
    klima_teknisyeni_gizle: true,
    icon: ThumbUpAltIcon,
  },
  {
    title: "Depo Sayım",
    href: '/Inventory',
    klima_teknisyeni_gizle: true,
    icon: LocalConvenienceStoreIcon,
  },
  {
    title: "Bayiden Alınacak Ürünler",
    href: '/DepoTakip',
    klima_teknisyeni_gizle: true,
    icon: LocalShippingIcon,
  },
  {
    title: "AEEE Fiş Eşleme",
    href: '/AeeeUrunEsle',
    klima_teknisyeni_gizle: true,
    icon: CompareIcon,
  },
  {
    title: text('Bultenler'),
    href: '/Bultenler',
    klima_teknisyeni_gizle: true,
    icon: FormatListBulletedIcon,
  },
  {
    title: 'Fişe Ekleri',
    href: '/Dosya',
    klima_teknisyeni_gizle: true,
    icon: AttachFileIcon,
  },
  {
    title: 'Günün Özeti',
    href: '/dashboards/default',
    klima_teknisyeni_gizle: true,
    icon: HomeIcon,
  },
  {
    title: text('Kullanici'),
    href: '/profile',
    icon: PersonIcon,
    items: [
      {
        title: text('Mesajlar'),
        icon: RiMessage2Line,
        href: '/profile/1/timeline'
      },
      {
        title: text('Plaka'),
        icon: FaTruck,
        href: '/profile/1/Plaka'
      },
      {
        title: text('Kayit'),
        icon: FaSave,
        href: '/profile/1/Kayit'
      },
      {
        title: text('Baglanti'),
        icon: GoDeviceMobile,
        href: '/profile/1/connections'
      },
      {
        title: text('Koordinat'),
        icon: GoLocation,
        href: '/profile/1/Lokasyon'
      },
      {
        title: 'Digiport',
        icon: ReportIcon,
        href: '/profile/1/Digiport'
      },
      ...(window.location.href.includes('local') || window.location.href.includes('test') ? [
        {
          title: 'Dijital Personel Kartı',
          icon: PersonelKarti,
          href: '#'
        }
      ] : [])
    ]
  },
  {
    title: 'Servis İletişim',
    href: '/ServisIletisim',
    icon: StoreIcon,
  },
  {
    title: 'Yardım',
    href: '/Yardim',
    icon: HelpIcon,
  },
];

export const NavBarAdetleriAl = (serviceShopId, TechnicianId) => {
  axios.get('/GetArtemisAdetler/' + serviceShopId + '/' + TechnicianId)
    .then((response) => {
      const res = response.data
      res.length > 0 && res.forEach(r => {
        switch (r.TIP) {
          case 'ISLER':
            setIslerAdet(r.ADET)
            break;
          case 'YORUM':
            setYorumAdet(r.ADET);
            break;
          case 'UYARI':
            setUyariAdet(r.ADET);
            break;
          case 'MALZEME_IHTIYAC':
            setMalzemeIhtiyacAdet(r.ADET);
            break;
          case 'SATIS_ADET':
            setSatisAdet(r.ADET);
            break;
          default:
            break;
        }
      });
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });
}


export const getIslerAdet = () => {
  return sessionStorage.getItem('IsAdet') || null;
}

export const setIslerAdet = (Adet) => {
  sessionStorage.removeItem('IsAdet');
  sessionStorage.setItem('IsAdet', Adet);
}

////////////////// UYARI ///////////////////////

export const getUyariAdet = () => {
  return sessionStorage.getItem('UyariAdet') || null;
}

export const setUyariAdet = (Adet) => {
  sessionStorage.removeItem('UyariAdet');
  sessionStorage.setItem('UyariAdet', Adet);
}

////////////////// SATIŞ ADET ///////////////////////

export const getSatisAdet = () => {
  return sessionStorage.getItem('SatisAdet') || null;
}
export const setSatisAdet = (Adet) => {
  sessionStorage.removeItem('SatisAdet');
  sessionStorage.setItem('SatisAdet', Adet);
}

////////////////// MALZEME IHTIYAÇ ///////////////////////

export const getMalzemeIhtiyacAdet = () => {
  return sessionStorage.getItem('MalzemeIhtiyacAdet') || null;
}

export const setMalzemeIhtiyacAdet = (Adet) => {
  sessionStorage.removeItem('MalzemeIhtiyacAdet');
  sessionStorage.setItem('MalzemeIhtiyacAdet', Adet);
}


//////////////// YORUM /////////////////////////////

export const getYorumAdet = () => {
  return sessionStorage.getItem('YorumAdet') || null;
}

export const setYorumAdet = (Adet) => {
  sessionStorage.removeItem('YorumAdet');
  sessionStorage.setItem('YorumAdet', Adet);
}
